import MainPageMain from "../components/main-page/MainPageMain";

const MainPage = () => {
	return <MainPageMain />;
};

export default MainPage;
